export default __webpack_public_path__ + "static/media/tweet_white.e2e77a9c.svg";